import { Symbology } from '@scandit/web-datacapture-barcode'
import modeSymbologies from './modeSymbologies'

export function parseSymbologiesFromURL(): { symbologies: Symbology[]; extensions: string[] } {
  let urlSymbologies = []
  const extensions = []
  const searchParams = new URLSearchParams(location.search)
  if (searchParams.has('dpm')) {
    urlSymbologies.push(Symbology.DataMatrix)
    extensions.push('direct_part_marking_mode')
  }

  const _urlSymbologies: Symbology[] = (searchParams
    .get('s')
    ?.split(',')
    .filter(function (s) {
      return s.trim() !== ''
    }) ?? []) as Symbology[]

  urlSymbologies.push(..._urlSymbologies)

  if (urlSymbologies.length > 0) {
    const allSymbologies = modeSymbologies.all
    const invalidSymbologies = urlSymbologies.filter((s) => !allSymbologies.includes(s))

    if (invalidSymbologies.length > 0) {
      // remove invalid symbologies from active symbologies
      urlSymbologies = urlSymbologies.filter((s) => {
        return allSymbologies.includes(s)
      })

      // remove invalid symbologies from URL
      const correctedUrl = new URL(location.href)
      if (urlSymbologies.length > 0) {
        correctedUrl.searchParams.set('s', urlSymbologies.join(','))
      } else {
        correctedUrl.search = ''
      }
      location.replace(correctedUrl)

      //TODO: notify user in another way?
      alert(`Following symbologies are invalid and were removed: ${invalidSymbologies.join(', ')}`)
    }
  }
  return { symbologies: urlSymbologies, extensions }
}
